

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
// Stateの初期状態
const initialState = {
    select_offer: {},

};

export const GetOfferTemplateList = createAsyncThunk("OfferTemplate/一覧取得", async (arg, thunkAPI) => {
    let url = "/api/GetOfferTemplateList";
    const params = arg;
    const headers = {
        "API-KEY": thunkAPI.getState().Information.token,
    };
    try {
        const response = await axios.post(url, params, {
            headers: { ...headers },
        });

        return response.data;
    } catch (err) {
        return thunkAPI.rejectWithValue(err.response.data);
    }
});

// Sliceを生成する
const slice = createSlice({
    name: "OfferTemplate",
    initialState,
    reducers: {
        initialize: (state, action) => {
            if (action.payload) {
                state[action.payload] = initialState[action.payload];
            } else {
                initialState;
            }
        },
        offer_template_set: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
    },
    extraReducers: {
        // お仕事検索
        [GetOfferTemplateList.fulfilled]: (state, action) => {
            const resdata = action.payload;

            // if (!resdata?.offer_list) return;
            // state.offer_list = resdata.offer_list;
        },
    },
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { initialize, offer_template_set } = slice.actions;

